import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueSvgInlinePlugin from "vue-svg-inline-plugin";

window.$ = require('jquery')
window.jQuery = require('jquery')

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import './assets/scss/globalColors.scss'
import './assets/css/global.css'

const app = createApp(App);

function isElectron() {
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
      return true;
  }

  if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
      return true;
  }

  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
      return true;
  }
  return false;
}

function isCordova(){
  if(window.hasOwnProperty("cordova")){
    return true;
  }

  if(typeof(cordova) == "object"){
    return true;
  }

  if(!!window.cordova){
    return true;
  }
  return false;
}

if (typeof process === 'undefined') {
  window.process = {
    env: {
      NODE_ENV: 'development', // O 'production', según tu entorno
    },
  };
  global.process = {
      version: 'v12.0.0'  // Puedes poner cualquier versión ficticia de Node.js
  };
}

app.config.globalProperties.$filters = {
    cap(data) {
        var capitalized = []
        data.split(' ').forEach(word => {
          capitalized.push(
            word.charAt(0).toUpperCase() +
            word.slice(1).toLowerCase()
          )
        })
        return capitalized.join(' ')
    },
    cash(value){
      if (typeof value !== "number") {
          return value;
      }
      var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
      });
      return formatter.format(value);
    }
}


app.config.globalProperties.isElectron = isElectron();
app.config.globalProperties.isCordova = isCordova();
app.config.globalProperties.version = require('../package.json').version;


app.use(VueSvgInlinePlugin, {
	attributes: {
		data: [ "src" ],
		remove: [ "alt" ]
	}
});

app.use(router).mount('#app');
